
<agpr-take-over-panel
    #panel
    [id]="'prominenceTakeOverPanel'"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    (visibleChange)="cancel()"
    [hideSlideOverlay]="hideSlideOverlay"
    [validateBeforeClose]="exitValidation$"
    [responsiveWidth]="true"
    [minPanelWidth]="550"
    [maxPanelWidth]="820"
    [showTopPadding]="false"
    header="AccountPreferences.prominence"
>
    <div
        class="agpr-prominenceTakeOverPanel-content"
        [agprLoading]="loading"
    >
        <div class="agpr-prominenceTakeOverPanel-header">
            <div class="agpr-prominenceTakeOverPanel-header-intro">
                {{ 'AccountPreferences.prominence.intro' | localize }}
                <p>{{ 'AccountPreferences.prominence.intro2' | localize }}</p>
            </div>
            <div class="agpr-prominenceTakeOverPanel-header-disclaimer">
                @if (hasProminenceProvision) {
                    <agpr-message
                        [severity]="prominenceStatus === prominenceStatuses.FAILED ? messageSeverityEnum.error : messageSeverityEnum.warning"
                    >
                        @if (prominenceStatus === prominenceStatuses.DONE || !prominenceStatus) {
                            <div [innerHTML]="'AccountPreferences.prominence.disclaimer.canEdit' | localize"></div>
                        }

                        @if (prominenceStatus === prominenceStatuses.ONGOING || prominenceStatus === prominenceStatuses.PENDING) {
                            {{ 'AccountPreferences.prominence.disclaimer.cannotEdit' | localize }}
                        }

                        @if (prominenceStatus === prominenceStatuses.FAILED) {
                            {{ 'AccountPreferences.prominence.disclaimer.contactEngineering' | localize }}
                        }
                    </agpr-message>
                } @else {
                    <agpr-message [severity]="messageSeverityEnum.info">
                        <div [innerHTML]="'AccountPreferences.prominence.disclaimer.noProminence' | localize: { contactLink: noProminenceContactLink }"></div>
                    </agpr-message>
                }
            </div>
        </div>

        @if (hasProminenceProvision && (prominenceStatus === prominenceStatuses.DONE || !prominenceStatus)) {
            <ul
                id="prominenceGroups"
                agprListKeyboardNavigation
                [list]="prominenceGroups"
            >
                @for (prominenceGroup of prominenceGroups; track prominenceGroup.id || prominenceGroup.tempUuid; let i = $index) {
                    <li
                        class="agpr-prominence-group agpr-contextMenu-parent"
                        [attr.aria-label]="prominenceGroup.name"
                    >
                        @if (prominenceGroup.editing) {
                            <div>
                                <agpr-text-input
                                    #nameInput
                                    class="agpr-prominenceTakeOverPanel-nameInput"
                                    label="AccountPreferences.prominence.name"
                                    [(ngModel)]="prominenceGroup.name"
                                    placeholder="AccountPreferences.prominence.name.placeholder"
                                    (ngModelChange)="checkErrors()"
                                    [maxLength]="32"
                                    [id]="'prominenceGroupName'"
                                ></agpr-text-input>
                                @if (prominenceGroup.nameExists) {
                                    <agpr-form-message>
                                        {{ 'AccountPreferences.prominence.update.error.uniqueName' | localize }}
                                    </agpr-form-message>
                                }

                                @if (prominenceGroup.emptyName) {
                                    <agpr-form-message>
                                        {{ 'AccountPreferences.prominence.update.error.emptyName' | localize }}
                                    </agpr-form-message>
                                }

                                <agpr-text-input-chips
                                    class="agpr-prominenceTakeOverPanel-chips"
                                    [id]="'prominenceGroupKeywords'"
                                    placeholder="AccountPreferences.prominence.keywords.placeholder"
                                    header="AccountPreferences.prominence.keywords"
                                    [(ngModel)]="prominenceGroup.keywords"
                                    (ngModelChange)="checkErrors()"
                                    [splitOnPattern]="splitOnPattern"
                                ></agpr-text-input-chips>

                                @if (prominenceGroup.emptyKeywords) {
                                    <agpr-form-message>
                                        {{ 'AccountPreferences.prominence.update.error.emptyKeywords' | localize }}
                                    </agpr-form-message>
                                }
                            </div>
                        } @else {
                            <div>
                                <div class="agpr-prominence-group-notEditing-name">
                                    {{ prominenceGroup.name }}
                                </div>
                                <agpr-chip-container
                                    [id]="'prominenceGroup_' + i + '_chips'"
                                    [chips]="prominenceGroup.keywords || []"
                                    [readonly]="true"
                                    [noTooltips]="true"
                                ></agpr-chip-container>
                            </div>
                        }

                        <div class="agpr-contextMenu top right agpr-prominence-corners">
                            @if (!prominenceGroup.editing && !disableEdit()) {
                                <agpr-button
                                    [icon]="'fa-regular fa-duotone fa-pen'"
                                    (click)="editGroup(i)"
                                    class="contextMenu"
                                    tooltip="AccountPreferences.prominence.contextMenu.edit"
                                    tooltipPosition="top"
                                    [style]="buttonTypes.contextMenu"
                                ></agpr-button>
                            }

                            @if (prominenceGroup.editing && !disableDone(prominenceGroup)) {
                                <agpr-button
                                    [icon]="'fa-regular fa-duotone fa-check'"
                                    (click)="doneEditing(prominenceGroup)"
                                    class="contextMenu"
                                    tooltip="AccountPreferences.prominence.contextMenu.confirm"
                                    tooltipPosition="top"
                                    [style]="buttonTypes.contextMenu"
                                ></agpr-button>
                            }

                            <agpr-button
                                [icon]="'fa-regular fa-duotone fa-trash-can'"
                                (click)="removeGroup(i)"
                                class="contextMenu"
                                tooltip="AccountPreferences.prominence.contextMenu.delete"
                                tooltipPosition="top"
                                [style]="buttonTypes.contextMenu"
                            ></agpr-button>
                        </div>
                    </li>
                }
            </ul>

            <span class="agpr-prominenceTakeOverPanel-addbutton">
                <agpr-button
                    label="AccountPreferences.prominence.addSubject"
                    [style]="buttonTypes.tertiary"
                    [disabled]="prominenceGroups.length >= prominenceGroupLimit || disableEdit()"
                    [tooltip]="prominenceGroups.length >= prominenceGroupLimit ? ('AccountPreferences.prominence.subjectLimitReached' | localize) : undefined"
                    (click)="addGroup()"
                ></agpr-button>
            </span>
        }
    </div>

    <ng-template #takeOverFooterLeft>
        <agpr-button
            [id]="'prominenceTakeOverPanel_cancel'"
            class="agpr-prominenceTakeOverPanel-cancelButton"
            label="cancel"
            [style]="buttonTypes.primaryB"
            (click)="hideSlideOverlay = true"
        ></agpr-button>
    </ng-template>

    <ng-template #takeOverFooterRight>
        <span
            id="prominenceTakeOverPanel_saveButton_disabledTooltip"
            class="u-srOnly"
        >
            {{ 'Account.save.noChangesToSave' | localize }}
        </span>

        <agpr-button
            [id]="'prominenceTakeOverPanel_save'"
            label="update"
            [style]="buttonTypes.primary"
            [disabled]="saveDisabled"
            [tooltip]="saveDisabledTooltip"
            [ariaDescribedBy]="'prominenceTakeOverPanel_saveButton_disabledTooltip'"
            (click)="update()"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
